<template>
	<div :class="{ row: display === 'row' }">
		<div>
			<label v-if="label" :for="identifier" :style="{ width: labelWidth + 'px' }">{{label}}</label>
			<textarea :id="identifier" :name="identifier" type="text" @change="$emit('input', $event.target.value); $emit('valueChanged');" :value="value" v-bind="attrs"></textarea>
		</div>
		<div class="error">
			<span v-if="error" class="errormessage">{{error}}</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TextareaInput',
		props: ['label', 'value', 'identifier', 'display', 'labelWidth', 'attrs', 'error']
	}
</script>

<style lang="scss" scoped>
	div.row div{
		display:flex;
		min-height: 100px;
    }

	label{
		margin-top:8px;
		margin-bottom:5px;
		display:block;
    }

	textarea {
		padding: 7px;
		width: 100%;
		border: 1px solid #e4e4e4;
	}

	.error {
		position:absolute;
		right:0;
		padding-top:3px;
		font-size:0.8em;
		color:#d43131;
	}

	.error span {
		width: 100%;
		text-align: right;
	}
</style>
